<template>
  <div class="max-w-[1100px] sm:w-full sm:mx-auto mb-3 mx-4 mt-8 sm:mt-9 sm:mb-9">
    <div class="flex justify-start items-center self-center space-x-3">
      <OIcon :icon="'message-question'" svg-class="w-6 sm:w-8 h-6 sm:h-8" />
      <h1 class="mb-2 whitespace-nowrap font-semibold text-md sm:text-22 mt-2">{{ $t('game.how-to-play') }}</h1>
      <hr class="border border-[#E2E5ED] w-full" />
    </div>

    <p class="text-md">
      <span class="whitespace-pre-line font-medium">{{ commentText }}</span>
      <span v-if="showAllTextButton" class="font-bold text-primary-300 hover:underline cursor-pointer" @click="showAllText">
        {{ $t('comment-item.see-more') }}
      </span>
    </p>
  </div>
</template>
<script>
import { defineComponent, useRoute, ref } from '@nuxtjs/composition-api';
import { truncate } from 'lodash';
import gameData from '../gameData';
import { useDevice } from '~/composables/useDevice';
import { LANG } from '~/constants/config';
import { escapeText } from '~/modules/common/utils/stringUtils';
import { OIcon } from '~/modules/common/components/ui';

export default defineComponent({
  components: { OIcon },
  setup(props) {
    const route = useRoute();
    const { isMobile } = useDevice();
    const slug = route.value.params.slug;
    const game = gameData.filter((g) => {
      return g.slug === slug;
    })[0];
    const commentText = ref(truncate(escapeText(game.description?.[LANG]), { length: 250 }));
    const showAllTextButton = ref(game.description?.[LANG]?.length > 250);
    const showAllText = () => {
      showAllTextButton.value = false;
      commentText.value = escapeText(game.description?.[LANG]);
    };
    return { showAllText, showAllTextButton, isMobile, game, commentText };
  },
});
</script>
